<template>
  <div>
    <div>
      <!-- Content goes here -->
      <div class="">
        <div class="Polaris-DataTable__Navigation">
          <button
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly Polaris-Button--disabled"
            aria-label="Scroll table left one column"
            aria-disabled="true"
            type="button"
            tabindex="-1"
          >
            <span class="Polaris-Button__Icon">
              <span class="Polaris-Icon">
                <svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"
                  ></path>
                </svg>
              </span>
            </span>
          </button>
          <button
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly"
            aria-label="Scroll table right one column"
            type="button"
          >
            <span class="Polaris-Button__Icon">
              <span class="Polaris-Icon">
                <svg
                  viewBox="0 0 20 20"
                  class="Polaris-Icon__Svg"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.72 14.53a.75.75 0 0 1 0-1.06l3.47-3.47-3.47-3.47a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z"
                  ></path>
                </svg>
              </span>
            </span>
          </button>
        </div>
        <div class="Polaris-DataTable">
          <div class="Polaris-DataTable__ScrollContainer">
            <table class="Polaris-DataTable__Table">
              <thead>
                <tr>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Campaign Name
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Status
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Created At
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Scheduled At
                  </th>
                  <th
                    data-polaris-header-cell="true"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                    scope="col"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="campaigns.docs.length === 0">
                  <td
                    colspan="5"
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop text-center"
                  >
                    Create a campaign to start sending marketing messages
                  </td>
                </tr>
                <tr
                  v-for="(campaign, index) of campaigns.docs"
                  :key="index"
                  class="Polaris-DataTable__TableRow Polaris-DataTable--hoverable"
                >
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    {{ campaign.name }}
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <span
                      class="Polaris-Badge"
                      :class="getCampaignBadgeTone(campaign.status)"
                    >
                      <span
                        class="Polaris-Text--root Polaris-Text--visuallyHidden"
                      >
                        {{ getCampaignBadgeA11yTone(campaign.status) }}
                      </span>
                      <span class="Polaris-Text--root Polaris-Text--bodySm">{{
                        getCampaignStatus(campaign.status)
                      }}</span>
                    </span>
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <span v-if="campaign.createdAt">
                      {{ campaign.createdAt | dateFilter }}
                    </span>
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <span v-if="campaign.scheduledAt">
                      {{ campaign.scheduledAt | dateFilter }}</span
                    >
                  </td>
                  <td
                    class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop"
                  >
                    <button
                      type="button"
                      class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantTertiary Polaris-Button--sizeMedium"
                      @click.stop="gotoCampaignDetail(campaign)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :page="campaigns" @pageChanged="loadPage" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

import Pagination from "../../components/Common/Pagination.vue";

export default {
  name: "Campaigns",
  components: {
    Pagination
  },
  filters: {
    dateFilter(value) {
      if (value) {
        return format(new Date(value * 1000), "h:mm a, MMM dd");
      }
      return "";
    }
  },
  data() {
    return {
      showModal: false,
      currentCampaign: null,
      isLoading: false
    };
  },
  computed: {
    campaigns() {
      return this.$store.getters["Marketing/getCampaigns"];
    }
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("Marketing/getCampaigns", {
        page
      });
      this.isLoading = false;
    },
    closeModal() {
      this.currentCampaign = null;
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew() {
      this.openModal();
    },
    onCreate() {
      this.loadCampaigns();
      this.closeModal();
    },
    getCampaignStatus(status) {
      switch (status) {
        case "waiting_for_approval":
          return "waiting for approval";

        default:
          return status;
      }
    },
    getCampaignBadgeTone(status) {
      switch (status) {
        case "scheduled":
          return "Polaris-Badge--toneSuccess";
        case "waiting_for_approval":
          return "Polaris-Badge--toneWarning";
        case "draft":
          return "Polaris-Badge--toneInfo";
        default:
          return "";
      }
    },
    getCampaignBadgeA11yTone(status) {
      switch (status) {
        case "scheduled":
          return "Success";
        case "waiting_for_approval":
          return "Warning";
        case "draft":
          return "Info";
        default:
          return "Status";
      }
    },

    gotoCampaignDetail(campaign) {
      this.$router.push({
        name: "CampaignDetail",
        params: { campaignId: campaign.id }
      });
    },
    deleteCampaign(campaign) {
      this.$store
        .dispatch("Marketing/deleteCampaign", {
          campaignId: campaign.id
        })
        .then(() => {
          this.loadCampaigns();
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
